.modal-basic.show-modal,
.modal-size-90.show-modal,
.modal-height-100.show-modal,
.modal-height-auto.show-modal {
  background: rgba(255, 255, 255, 0.32);
  --box-shadow: 0 24px 38px 0 rgba(0, 0, 0, 0.14), 0 9px 46px 0 rgba(0, 0, 0, 0.12), 0 11px 15px 0 rgba(0, 0, 0, 0.2) !important;
}

/* When modals use shadow dom, the ion-page classes that are part of ionic framework don't apply */
:host(.concourse-modal) {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.concourse-modal ion-header,
:host(.concourse-modal) ion-header {
  box-shadow: none !important;
  border-bottom: 1px solid var(--background-color-step-200);
}

.concourse-modal ion-footer,
:host(.concourse-modal) ion-footer {
  box-shadow: none;
  border-top: 1px solid var(--background-color-step-200);
}

/* Host padding does not reach the label; ion-button uses --padding-* on .button-native */
.concourse-modal ion-footer ion-button[shape='round'],
:host(.concourse-modal) ion-footer ion-button[shape='round'] {
  --padding-start: 16px;
  --padding-end: 16px;
}

/**
 * Allows the modal content to scroll if it is taller than 100vh
 * This only really affects modals with one of the size classses:
 * modal-height-auto
 * modal-size-90
 * modal-full-view
**/
.concourse-modal .modal-content,
:host(.concourse-modal) .modal-content {
  overflow-y: auto;
  flex: 1;
  max-height: calc(100vh - 114px); /* The header and footer together are 113px */
  scrollbar-width: thin;
  scrollbar-color: grey transparent;
  /* scrollbar-gutter: stable; causing extra gaps on concourse-menu */
  overflow-y: auto;
}

.concourse-modal ion-page,
:host(.concourse-modal) ion-page,
.concourse-modal ion-content,
:host(.concourse-modal) ion-content,
.concourse-modal ion-list,
:host(.concourse-modal) ion-list,
.concourse-modal ion-item,
:host(.concourse-modal) ion-item,
.concourse-modal ion-toolbar,
:host(.concourse-modal) ion-toolbar,
.concourse-modal ion-toolbar::part(background) {
  color: var(--ion-text-color);
  --background: transparent !important;
  background-color: transparent !important;
}

@media (min-width: 768px) {
  /* modal-height-auto is the default and is used for most modals */
  .modal-height-auto::part(content) {
    --height: auto;
  }

  /* Modals have rounded corners and a lighter grey background */
  .modal-basic::part(content),
  .modal-size-90::part(content),
  .modal-height-100::part(content),
  .modal-height-auto::part(content) {
    border-radius: 1rem;
    --background: var(--background-color-step-50);
  }

  .modal-sidepanel {
    position: absolute;
    top: 57px;
    bottom: 0;
    right: 0;
    width: 400px;
    height: calc(100vh - 57px);
    margin-left: calc(100vw - 400px);
  }

  .modal-sidepanel::part(content) {
    border-radius: 1rem 0 0 0; /* Round the top left corner */
    --background: var(--background-color-step-50);
    height: 100%; /* Fill the modal which has a constrained height */
  }
  .modal-sidepanel::part(backdrop) {
    /* Make the backdrop transparent to mouse */
    display: none;
  }

  /* 
   * modal-full-view is used for modals that are full screen - used for document viewer modals. 
   * Modals that fill the screen do not have rounded corners and use the dark background color
   */
  .modal-full-view {
    --width: 100%;
    --height: 100%;
  }
  .modal-full-view::part(content) {
    border-radius: 0 !important;
    --background: var(--ion-background-color, black);
  }

  /* modal-size-90 is used for modals that are 90% of the screen width and height - used for photo gallery modal. */
  .modal-size-90 {
    --height: 90%;
    --width: 90%;
  }

  /* modal-height-100 is used for modals that are 100% of the screen height, such as person selector modal. */
  .modal-height-100 {
    --height: 100%;
  }

  /*
   * The modal on large screens has no back button, so the title needs to be bumbed out from the edge
   */
  .modal-title {
    padding-left: 12px;
    max-width: 500px;
    text-overflow: ellipsis;
  }

  .concourse-modal ion-footer,
  :host(.concourse-modal) ion-footer {
    padding: 0 16px;
  }
}

@media (max-width: 768px) {
  /* Modals on mobile have a dark background because it represents a navigation action */
  :host(.concourse-modal)::part(content),
  .concourse-modal::part(content) {
    --background: var(--ion-background-color, black);
  }

  /** Modal footer on mobile has more padding because the buttons are stacked vertically */
  :host(.concourse-modal) ion-footer,
  .concourse-modal ion-footer {
    padding: 10px 16px;
  }

  /** Modal footer toolbar on mobile has flexible height */
  :host(.concourse-modal) ion-footer ion-toolbar,
  .concourse-modal ion-footer ion-toolbar {
    --min-height: auto;
  }

  /* Buttons stack on mobile footer */
  :host(.concourse-modal) ion-footer ion-toolbar::part(container),
  .concourse-modal ion-footer ion-toolbar::part(container) {
    flex-direction: column-reverse;
    gap: 8px;
  }

  /* Make the buttons full width on mobile */
  :host(.concourse-modal) ion-footer ion-button,
  .concourse-modal ion-footer ion-button {
    width: 100%;
    margin: 0;
  }
}

/**
   * By default the date picker modal is white and does not wrap the picker
   * These classes help it fit in with  the dark scheme.
   */
.date-picker-modal {
  --background: #333;
  --width: fit-content;
  --min-width: 250px;
  --height: fit-content;
  --border-radius: 6px;
  --box-shadow: 0 28px 48px rgba(0, 0, 0, 0.4);
}

ion-datetime {
  --background: #201f1f;
}
